import { useState, useEffect } from "react";

const initialsOf = (name) =>
  (name || "?").trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "?";

export function Avatar({ userId, name, size = 36, updatedAt, className = "" }) {
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); }, [userId, updatedAt]);
  const src = userId
    ? `${process.env.REACT_APP_BACKEND_URL}/api/avatars/${userId}${updatedAt ? `?v=${encodeURIComponent(updatedAt)}` : ""}`
    : null;
  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-secondary ${className}`}
      style={{ width: size, height: size }}
      data-testid={userId ? `avatar-${userId}` : undefined}
    >
      {src && !err ? (
        <img src={src} alt="" className="h-full w-full object-cover" onError={() => setErr(true)} />
      ) : (
        <span className="font-display font-bold text-muted-foreground" style={{ fontSize: Math.round(size * 0.4) }}>
          {initialsOf(name)}
        </span>
      )}
    </div>
  );
}
